export enum Align {
  center = 'center',
  left = 'left',
  right = 'right',
  justify = 'justify',
  top= 'top',
  bottom = 'bottom',
  none = 'none'
}

export const AlignValues = Object.values(Align)
export type AlignArray = typeof AlignValues
export type TypeAlign = AlignArray[number]
